import React, { useCallback, useState } from "react";

/** External libraries */
import { Menu } from "@libraries/mui/icons";
import { SidebarDrawer } from "@npm-telluria-tecnologia/telluria-ui";
/** Atoms */
import Logo from "@atoms/TopconLogo";
/** Assets */
import SmallIdentityLogo from "@assets/TopconLogo/Identity_IconAndName_Small.svg";
/** Molecules */
import { NavbarIcons } from "@molecules/index";
import SidebarDrawerMenus from "@molecules/SidebarDrawerMenus";
import SidebarDrawerSecondaryMenus from "@molecules/SidebarDrawerSecondaryMenus";
/** Hooks */
import useTheme from "@styles/useTheme";
/** Styled components */
import * as Styled from "./styles";

/** Component */
const Navbar: React.FC = () => {
  const { theme } = useTheme();

  const [openSidebar, setOpenSidebar] = useState(false);

  const toggleOpenSidebar = useCallback(() => {
    setOpenSidebar((value) => !value);
  }, []);

  return (
    <Styled.Container>
      <Menu onClick={toggleOpenSidebar} />
      <SidebarDrawer
        primarycolor={theme.brand.navy}
        productIconPath={SmallIdentityLogo}
        open={openSidebar}
        onClose={toggleOpenSidebar}
        bodyChildren={<SidebarDrawerMenus />}
        footerChildren={<SidebarDrawerSecondaryMenus />}
      />
      <Styled.LogoContainer aria-label="Topcon Suite">
        <Logo horizontal />
      </Styled.LogoContainer>

      <NavbarIcons />

    </Styled.Container>
  );
};

export default React.memo(Navbar);
